<script setup lang="ts">

</script>

<template>
  <div class="page-container">
    <div class="text-center py-6 pt-10" v-show="isLoaded">
      <font-awesome-icon class="text-gray-500" :icon="['fas', 'circle-notch']" transform="grow-6" spin />
    </div>
    <div v-show="!isLoaded">
      <div class="grid md:grid-cols-2 sm:grid-cols-2 xs:grid-cols-1 py-2">
        <div class="float-left py-2 px-2">
          <div class="p-6 h-32 xl:h-auto bg-green-100 rounded-md">
            <div class="">
              {{ $t("messages.player.userTransactionSummaries.totalDepositAmount") }}
            </div>
            <span class="block text-4xl mt-1">
              {{
                pageData?.totalDepositAmount
                    ? parseFloat(pageData?.totalDepositAmount/100).toLocaleString(
                        "en",
                        {
                          useGrouping: true,
                          minimumFractionDigits: 2,
                        }
                    )
                    : Number(0).toFixed(2)
              }}
            </span>
          </div>
        </div>
        <div class="float-left py-2 px-2">
          <div class="p-6 h-32 xl:h-auto bg-green-100 rounded-md">
            <div class="">
              {{ $t("messages.player.userTransactionSummaries.totalDepositCount") }}
            </div>
            <span class="block text-4xl mt-1">
              {{
                pageData?.totalDepositCount? pageData.totalDepositCount: 0
              }}
            </span>
          </div>
        </div>
        <div class="float-left py-2 px-2">
          <div class="p-6 h-32 xl:h-auto bg-red-100 rounded-md">
            <div class="">
              {{ $t("messages.player.userTransactionSummaries.totalWithdrawAmount") }}
            </div>
            <span class="block text-4xl mt-1">
              {{pageData?.totalWithdrawAmount
                ? parseFloat(pageData?.totalWithdrawAmount/100).toLocaleString(
                    "en",
                    {
                      useGrouping: true,
                      minimumFractionDigits: 2,
                    }
                )
                : Number(0).toFixed(2)
              }}
            </span>
          </div>
        </div>
        <div class="float-left py-2 px-2">
          <div class="p-6 h-32 xl:h-auto bg-red-100 rounded-md">
            <div class="">
              {{ $t("messages.player.userTransactionSummaries.totalWithdrawCount") }}
            </div>
            <span class="block text-4xl mt-1">
              {{
                pageData?.totalWithdrawCount? pageData.totalWithdrawCount: 0
              }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {inject, ref, onMounted} from "@vue/runtime-core";
import store from "@/store";
import {useRoute} from "vue-router";

export default {
  setup(){
    const axios = inject("$axios");
    const isLoaded = ref(false);
    const pageData = ref()
    const route = useRoute();

    onMounted(() => {

      fetchPageData();
    });

    const fetchPageData = async () => {
      isLoaded.value = true;
      const payload = {
        operatorId: store.state.selectedOperator.operatorId,
      };
      const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/be-payment/user-transaction-summaries/${route.params.id}`;
      const {data} = await axios.post(url, payload)
      pageData.value = data;
      isLoaded.value = false
    };

    return {
      isLoaded,
      pageData,
    }
  }
}

</script>
